<template>
  <div class="agreement">
    <AppNavbar
      :zIndex="999"
      :placeholder="true"
      title="课程服务协议"
    ></AppNavbar>
    <div class="line bold"
      >提示：在使用“betterWE 减脂营 ”课程服务之前，请您先认真阅读本《课程服务
      协议》（以下简称“本协议
      ”），在充分理解并同意遵守本协议各条款内容，特别是免除
      或者限制责任的条款、争议解决和法律适用条款后再进行本站课程服务的购买和使用。
      免除或者限制责任的条款可能将以加粗字体显示，您应重点阅读。如您对本协议有任何
      疑问的，应向本站客服咨询。本协议只适用于个人用户，不适用于企业用户及其员工。</div
    >
    <div class="line bold">一协议确认</div>
    <div class="line"
      >1、本协议是您(以下简称“您 ”或“用户 ”)基于对“betterWE 减脂营 ”课程服务
      方式的认可、学习计划的认同、 自身的需求，与 betterWE
      减脂营课程的所有者【长沙 健盟网络科技有限公司】（以下简称为“本公司
      ”）之间就本课程服务等相关事宜所订立
      的契约，经平等协商，双方自愿签订本课程服务协议。</div
    >
    <div class="line"
      >2、<span class="bold"
        >请您仔细阅读本课程服务协议，当您按照本协议提示填写信息、阅读并同意本
        协议且完成全部订立程序后，即表示您已充分阅读、理解并接受本协议的全部内容，本
        协议即构成对双方有约束力的法律文件。您承诺接受并遵守本协议的约定，届时您不应
        以未阅读本协议的内容或者未获得本站对您问询的解答等理由，主张本协议无效，或要
        求撤销本协议。</span
      ></div
    >
    <div class="line"
      >3、如果您在 18 周岁以下，则只能在父母或监护人的监护参与下才能参与报名本课
      程。<span class="bold"
        >若您不具备完全民事行为能力，则您的监护人应承担因此而导致的一切后果，本公
        司有权注销或永久停止您的课程，并向您及其监护人索偿相应损失。</span
      ></div
    >
    <div class="line"
      >4、<span class="bold"
        >本课程旨在帮助您调整饮食结构，合理饮食，本公司不对效果进行保证。希望
        您能严格按照营养师的建议进行合理饮食，收获您满意的效果。</span
      ></div
    >
    <div class="line bold">二课程服务管理</div>
    <div>1、betterWE 减脂营：</div>
    <div>betterWE 减脂营包含内容，具体如下</div>
    <div>（1）betterWE 减脂营课程</div>
    <div class="line bold"
      >购买该课程后，小鹅通内的视频、图文课程可以永久观看。</div
    >
    <div>（2）betterWE 减脂营服务</div>
    <div class="line"
      >课程有效期内，每日固定时间在微信社群进行答疑，（具体见课程公
      布的课程时间安排），用户可在相应的答疑时间内进行咨询、打卡。<span
        class="bold"
        >课程打卡套餐中到
        期未使用的课时将失效，不可延期，正式开营后享有1次7天内全额退款的权益（包含开营大会当天），具体见下文退款规则</span
      ></div
    >
    <div>2、课程管理规则</div>
    <div class="line bold"
      >用户根据其购买的课程享受相应的开课和延期权利，若不能参与相应的课程，请在
      课程开始日期前两天，联系客服，每位用户仅享有一次申请延期开课的权利</div
    >
    <div>3、其他课程套餐</div>
    <div class="line"
      >本公司开发、更新课程套餐的具体内容以官方渠道网站公示内容为准。</div
    >
    <div class="bold">三课程预约</div>
    <div class="line"
      >课程预约全部采用<span class="bold"
        >网络自助式，用户需自行在官方渠道（抖
        音、淘宝、小鹅通）购买课程并预约，本公司不提供电话预约等其他预约形式。</span
      ></div
    >
    <div class="bold">四费用支付</div>
    <div class="line"
      >用户在官方购买后可以通过支付宝、微信等方式进行课程费用的支付，在本公司收
      到用户款项后根据用户预约的课程开通相应的课程服务。</div
    >
    <div class="bold">五退课、延期课程管理</div>
    <div class="line"
      >除本协议另有约定或本公司官方网站另行公告外，用户在购买课程套餐后，<span
        class="bold"
        >如不愿使用本公司所提供的课程服务，欲申请退费、延期的，请微信联
        系客服，</span
      >本公司将按照以下约定办理：</div
    >
    <div class="bold">1、退费规则</div>
    <div
      >A、<span class="bold"
        >用户在开课之前可以无理由退款，如购课时领取了赠品，退课需扣除赠品金额</span
      ></div
    >
    <div
      >B、<span class="bold"
        >用户理解并同意，
        自课程开课之日（包含开营大会当天）7日内，按要求参与课程完成相关任务，未达到保底减重效果，可享有1次全额退款机会（需扣除赠品金额）；课程参与要求及退款规则入下，如因用户自身原因未未按时参加课程的，本公司不予退还任何费用</span
      ></div
    >
    <table>
      <tr>
        <td></td>
        <td>饮食打卡率</td>
        <td>饮食平均分</td>
        <td>体测次数</td>
      </tr>
      <tr>
        <td>一周参与要求</td>
        <td>100%</td>
        <td>≥95分</td>
        <td>2</td>
      </tr>
      <tr>
        <td>一周保底减重</td>
        <td rowspan="1" colspan="3"
          ><div>减重≥自身体重1%<br />或<br />腰围下降≥2cm</div></td
        >
      </tr>
    </table>
    <div class="line bold"
      >如有特殊情况不符合以上退款规则：身体疾病(多囊，甲状腺疾病，服用激素类药物、中药)或曾有过极端减肥经历(液断、辟谷、生酮、节食)</div
    >
    <div class="line"
      >退款金额=课程实付金额-（课程实付金额/课程规定服务天数*已服务天数）</div
    >
    <div class="line"
      >例如高定小班实付金额3599，服务10天提出退款，退款金额为：3599-（3599/90*10）=3199</div
    >
    <div
      >(1)如无特殊要求，退款金额将按照用户的原支付方式进行退还， 由本公司退还至
      用户的付款账户。<span class="bold"
        >如有特殊情况的，用户本人需要书面提供本人银行账户及相关支付信
        息进行退款申请，退款将支付到由用户书面提供的本人银行账户（退款会在十个工作日
        之内到账）。因退款产生的相关费用（含邮寄费、税费等）由用户自行承担，如本公司
        先行承担的，其有权在支付退款费用时直接予以扣除。如用户采用信贷方式购买课程的，
        则退款方式按照用户与信贷方的约定为准</span
      ></div
    >
    <div class="line"
      >(2)用户明确理解并同意，本公司向用户赠送的课程、优惠等将在用户购买的课程
      套餐使用完毕后方能开始使用。<span class="bold"
        >如用户提前申请退费，用户在购买课程时赠送的课程、
        优惠等项目自动取消，用户不得申请折算为现金进行退款</span
      ></div
    >
    <div class="bold">2、延期规则</div>
    <div class="bold">A、用户在开课前可以无理由申请延期开课一次</div>
    <div class="bold">B、用户自课程开课之日起三（3） 日内申请延期的</div>
    <div class="bold"
      >非不可抗力因素、非身体疾病因素不得延期，如有身体疾病因素须出示证明，否则
      不予延期</div
    >
    <div class="bold">C、用户自课程开课之日起三（3） 日后申请延期的</div>
    <div class="bold"
      >本公司将收取用户已使用课时（含用户旷课）费用，计算公式如下：</div
    >
    <div class="bold">补收费用 = 开课天数 * 课程单价</div>
    <div class="bold">支付上述费用后，用户可以另行选择日期重新开课</div>
    <div class="bold line"
      >用户理解并同意， 自课程开课之日起七（7） 日后，不再要求延期，如因用户自身
      原因未按时参加课程的，本公司不予退还任何费用</div
    >
    <div class="bold">六知识产权</div>
    <div class="line"
      >本网站上所显示、使用或提供之软件、程序及内容（包括但不限于文字、说明、图
      画、图片、图形、课程资源、页面设计、网站规划与安排等）之专利权、著作权、商标权、商业秘密及其他知识产权均属本公司或其他权利人所有，<span
        class="bold"
        >非经权利人事先书面授权
        同意，用户不得重制、公开传播、公开播送、公开上映、改作、编辑、转载、链接、引
        用、抓取、解编、反向破译、或其他方式之使用。如有违反时，除应承担法律责任外，
        还应承担对本公司造成的全部损失。</span
      ></div
    >
    <div class="bold">七争议解决</div>
    <div class="line"
      >协议中如有其它未尽事宜，双方依据本公司的官方网站公示内容为准，其他未尽事
      宜或执行过程中发生的其它问题由双方协商解决，协商不成，可提交本公司所在地有管
      辖权法院诉讼解决。</div
    >
    <div class="bold">八其他事宜</div>
    <div class="line"
      >1、<span class="bold"
        >本公司有权根据法律法规的变化及网站运营的需要不时地对本协议及本站的内
        容进行修改，并在本站张贴。修改后的协议一旦被张贴在本站上即生效，并代替原来的
        协议，用户可随时登录查阅最新协议。用户有义务及时关注并阅读最新版的协议及网站
        公告。如用户不同意更新后的协议，可以立即向本公司进行反馈且应立即停止接受本公
        司依据本协议提供的服务；如用户继续使用本站提供的服务的，即视为同意更新后的协
        议。</span
      ></div
    >
    <div class="line"
      >2、<span class="bold"
        >本协议自用户完成本课程协议的注册程序且将所选课程的款项支付至本公司账
        户后生效。</span
      ></div
    >
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavbar
  },
  data() {
    return {}
  },
  async created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.agreement {
  padding: 30px 20px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 12px;

  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .line {
    margin-bottom: 20px;
  }

  .bold {
    font-weight: bold;
  }
  table {
    font-size: 12px;
    margin: 10px 0;
    text-align: center;
    border-collapse: collapse;
    border: 1px solid #000;
  }
  td {
    border: 1px solid #000;
    padding: 4px 8px;
  }
}
</style>
